export const isEmbeddedBrowser = () => {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isInstagram = ua.includes('Instagram');
  const isFacebook = ua.includes('FBAN') || ua.includes('FBAV');
  const isLine = ua.includes('Line');

  const isIos = /iPhone|iPad|iPod/.test(ua);
  const isChromeIos = /CriOS/.test(ua); // Chrome iOS
  const isSafariIos = isIos && /Safari/.test(ua) && !isChromeIos;

  const isGenericWebView = /WebView/.test(ua) || (isIos && !isChromeIos && !isSafariIos);

  return (
    isInstagram ||
    isFacebook ||
    isLine ||
    isGenericWebView
  );
};
